import { CartonShortageStatus, PackingStatus, PouchShortageStatus, ShiftsEnum, StockTypeStatus } from "@gtpl/shared-models/analytics-data";
import { TransactionType } from "@gtpl/shared-models/common-models";
import { Column, Entity, PrimaryColumn } from "typeorm"
import { Shifts } from "./dto/shifts.enum";

@Entity('stock_in', { schema: 'public' })
export class StockInEntity{
    @PrimaryColumn('int', {
        name: 'reporting_log_id',
        width: 11
    })
    reportingLogId: number;

    @Column('date',{
        name: 'reporting_date',
    })
    reportingDate: Date;

    @Column('int',{
        name: 'sale_order_id',
        width: 11
    })
    saleOrderId: number;

    @Column('int',{
        name: 'sale_order_item_id',
        width: 11
    })
    saleOrderItemId: number;

    @Column('int',{
        name: 'reported_cases',
        width: 11
    })
    reportedCases: number;

    @Column('int',{
        name: 'loose_pouches',
        width: 11
    })
    loosePouches: number;

    @Column('int',{
        name: 'rack_postion',
        width: 11
    })
    rack_postion: number;

    @Column('varchar',{
        name: 'reported_person',
        length: 50
    })
    reportedPerson: string;

    @Column('varchar',{
        name: 'lot_code',
        length: 50
    })
    lotCode: string;

    @Column({
        type: 'enum',
        enum: Shifts,
        nullable: false,
        name: 'shift'
    })
    shift: string;

    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'transaction_type'
    })
    transactionType: string;

    @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: false,
        name: 'packing_completed'
    })
    packingCompleted: string;

    @Column('int',{
        nullable:true,
        name: 'stock_id',
        width: 11
    })
    stockId: number;

    @Column("int",{
        nullable:false,
        name:"unit_id",
        })
    plantId:number;

    @Column("int",{
        nullable:false,
        name:"manual_reported",
        })
    manualReported:number;

    @Column("int",{
    nullable:false,
    name:"cold_storage_id",
    })
    coldStorageId:number;

    @Column('varchar',{
        name: 'po_number',
        length: 50
    })
    poNumber: string;

    @Column({
        name: "created_at",
        type:"datetime"
        })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length:50,
        default:"Admin",
    })
    createdUser: string | null;

    @Column("int",{
        nullable:false,
        name:"trace_code",
    })
    traceCode:number;
    
    @Column("varchar", {
        nullable: true,
        name: "remarks",
        length:100
    })
    remarks: string | null;

    @Column("int", {
        name: "is_active",
        width:4
    })
    isActive: number;
    
    @Column("int", {
        name: "variant_id",
        width:11
    })
    variantId: number;
    
    @Column("int", {
        name: "brand_id",
        width:11
    })
    brandId: number;

    @Column("int", {
        name: "pack_style_id",
        width:11
    })
    packStyleId: number;

    @Column({
        type: 'enum',
        enum: PouchShortageStatus,
        nullable: false,
        name: 'pouches_shortage'
    })
    pouchesStorage: string;

    @Column({
        type: 'enum',
        enum: CartonShortageStatus,
        nullable: false,
        name: 'cartons_shortage'
    })
    cartonsStorage: string;

    @Column({
        type: 'enum',
        enum: StockTypeStatus,
        nullable: false,
        name: 'stock_type'
    })
    stockType: string;
   

    @Column("varchar", {
        name: "rack_position_code",
        length:50,
    })
    rackPositionCode: string;

    @Column("varchar", {
        name: "unit_code",
        length:50,
    })
    unitCode: string;

    @Column("varchar", {
        name: "cold_storage_code",
        length:50,
    })
    coldStorageCode: string;

    @Column("varchar", {
        name: "t_code",
        length:50,
    })
    tCode: string;

    @Column("varchar", {
        name: "variant_code",
        length:50,
    })
    variantCode: string;

    @Column("varchar", {
        name: "brand",
        length:50,
    })
    brand: string;

    @Column("varchar", {
        name: "no_of_pouches",
        length:50,
    })
    noOfPouches: string;

    @Column("varchar", {
        name: "pouches_per_row",
        length:50,
    })
    pouchesPerRow: string;
    
    @Column("varchar", {
        name: "uom",
        length:50,
    })
    uom: string;
}